import React, { FC, Fragment, useState } from 'react';
import { makeStyles, TableRow, TableCell, Link } from '@material-ui/core';
import LaunchOutlined from '@material-ui/icons/LaunchOutlined';

import { UserSegmentFragment, ContentEmailHistoryFragment } from 'api';
import DateCell from './DateCell';
import MessageCell from './MessageCell';
import PreviewDialog from './Preview';
import DeliveryInterval from './DeliveryInterval';

interface IProps {
  item: ContentEmailHistoryFragment;
  index: number;
  segments: UserSegmentFragment[];
}

const useStyles = makeStyles(theme => ({
  row: {
    verticalAlign: 'top',
    marginTop: theme.spacing(1),
  },
  cell: {
    paddingTop: theme.spacing(1),
  },
  title: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(2),
    display: 'inline-block',
  },
}));

const SentEmailRow: FC<IProps> = props => {
  const { item, index, segments } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const recipients = item.registered_user_count + item.unregistered_user_count;

  function handlePreview() {
    setOpen(true);
  }

  return (
    <Fragment>
      <TableRow key={index} className={classes.row}>
        <DateCell
          sendAt={item.sent_at}
          deliveryInterval={<DeliveryInterval interval={item.spec.delivery_interval} />}
        />
        <MessageCell
          segments={segments}
          id={item.spec.id}
          title={item.spec.title}
          segmentIds={item.spec.segment_ids}
          subject={item.spec.subject}
          intro={item.spec.intro}
          contentSpecs={item.spec.content_specs.length}
          postTypes={item.spec.content_specs}
        />
        <TableCell align="center">{recipients}</TableCell>
        <TableCell align="center">{item.total_opened}</TableCell>
        <TableCell align="center">{item.total_clicks}</TableCell>
        <TableCell>
          <Link onClick={handlePreview}>
            <LaunchOutlined fontSize="small" />
          </Link>
        </TableCell>
      </TableRow>
      <PreviewDialog open={open} onClose={() => setOpen(false)} values={item.spec} />
    </Fragment>
  );
};

export default SentEmailRow;
